module.exports = __webpack_public_path__ + "media/images/emblems/Logo_Le_Chenit-54c162a5e6c4a55179c536deb92d96d9.png";